export default __webpack_public_path__ + "static/media/icon-github-inv.ba04418b.svg";